import React, { useEffect, useMemo} from "react";
import LogoHeader from "../components/Header/LogoHeader";
import Footer from "../components/Footer/Footer";

const MainLayout = ({ children }) => {
  useEffect(() => {
    sessionStorage.removeItem("isRedirected");
  }, []);

  // ✅ Memoizing the JSX to avoid unnecessary recalculations (only if necessary)
  const memoizedLayout = useMemo(() => (
    <div className="container-fluid flex flex-col bg-pl-bg justify-between min-h-screen">
      <LogoHeader />

      <main className="container mx-auto flex-grow flex items-center justify-center mb-20 pt-[80px] text-14 md:text-15">
        {children}
      </main>

      <Footer />
    </div>
  ), [children]); // Dependency array ensures re-memoization only when `children` change.

  return memoizedLayout;
};

export default MainLayout;
